(function () {
    'use strict';

    function partnerFanOut($state, $mdDialog, $timeout) {
        return {
            restrict: 'E',
            templateUrl: 'workflow/directives/templates/partnerFanOut.html',
            scope: {
                phaseIndex: '@',
                entitySearchIndex: '@',
                adminEntitySearchIndex: '@',
                path: '@',
                partners: '=',
                message: '@',
                canAddPartners: '=',
                maxPartnersToShow: '@?',
                showAddPartnersPrompt: '=?'
            },
            link: function (scope, element, attrs) {
                scope.maxPartnersToShow = parseInt(scope.maxPartnersToShow || 4, 10);

                $timeout(function () {
                    scope.isLoaded = true;
                });

                scope.sharingState = '';
                scope.expandedPartners = scope.partners.slice(0, 
                    Math.min(scope.partners.length, scope.maxPartnersToShow));
                
                scope.additionalPartnerCount = scope.partners.length - 
                    scope.expandedPartners.length;

                scope.goToEntitySearch = function() {
                    switch (scope.sharingState) {
                        case ('workflow.sharingsearch.phase'):
                            $state.go('workflow.sharingsearch.phase', {
                                entitySearchIndex: scope.entitySearchIndex,
                                path: scope.path,
                                phaseIndex: scope.phaseIndex
                            });
                            break;
                        case ('workflow.sharingsearch'):
                            $state.go('workflow.sharingsearch', {
                                entitySearchIndex: scope.entitySearchIndex,
                                path: scope.path
                            });
                            break;
                        case ('workflow.sharingsearch.internalfiles'):
                            $state.go('workflow.sharingsearch.internalfiles', {
                                entitySearchIndex: scope.entitySearchIndex,
                                path: scope.path
                            });
                            break;
                    }
                }

                if (Number.isNaN(parseInt(scope.phaseIndex))) {
                    scope.sharingState = scope.path.indexOf('InternalContent') !== -1
                        ? 'workflow.sharingsearch.internalfiles'
                        : 'workflow.sharingsearch';
                }
                else if (parseInt(scope.phaseIndex) == -1) {
                    scope.sharingState = 'workflow.sharingsearch';
                }
                else {
                    scope.sharingState = 'workflow.sharingsearch.phase';
                }

                var originatorEv;
                scope.openPartnersMenu = function($mdOpenMenu, ev) {
                    originatorEv = ev;
                    $mdOpenMenu(ev);
                    };
            }
        };
    }

    partnerFanOut.$inject = ['$state', '$mdDialog', '$timeout'];

    angular.module('ecap.workflow').directive('partnerFanOut', partnerFanOut);
})();

